import PropTypes from 'prop-types'
import React, { Component } from 'react'

class Updates extends Component {
  state = {}
  render = () => {
    const { news } = this.props

    if (!news) return

    const rows = news.map((onenews, i) => {
      return (
        <tr className="onenews" key={i}>
          <td className="date">{onenews.date}</td>
          <td className="content">
            <p>{onenews.content}</p>
          </td>
        </tr>
      )
    })
    return (
      <table className="news">
        <tbody>{rows}</tbody>
      </table>
    )

    return <div className="row">{newsElem}</div>
  }
}

Updates.displayName = 'Updates'
Updates.propTypes = {
  images: PropTypes.array,
}

export default Updates



// WEBPACK FOOTER //
// ./src/components/updates.js